/**
 * @module chartConfigs/nullHandling/isNullDataPoint
 * @description 判断折线 series 单点是否为空值（后端 / ECharts 常见形态）
 */

/**
 * 是否为「空值数据点」（不含合法数值 0）。
 * 合法 0 返回 false，供 nullUi='0' 模式与 setAloneSymbolOpacity 区分使用。
 */
export const isNullDataPoint = (
  value: string | number | null | undefined,
): boolean => {
  if (value === null || value === undefined) {
    return true;
  }
  if (value === '') {
    return true;
  }
  if (value === 'null') {
    return true;
  }
  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return true;
  }
  return false;
};
